<template>
  <div
    class="top-bar color-scheme-dark position-fixed"
    style="width: 100%; z-index: 99"
  >
    <!--------------------START - Top Menu Controls -------------------->
    <div class="top-menu-controls hidden-mobile">
      <!--------------------  START - Settings Link in secondary top menu -------------------->
      <div
        class="
          messages-notifications
          os-dropdown-trigger os-dropdown-position-left
        "
        @click="verExtensiones()"
        @mouseover="popUpTelTrue()"
        @mouseleave="popUpTelFalse()"
      >
        <i class="os-icon os-icon-phone"></i>
        <div v-if="popUpTel == true" class="new-messages-count">
          <span> extenciones&#10532;</span>
        </div>
      </div>
      <div
        class="
          messages-notifications
          os-dropdown-trigger os-dropdown-position-left
        "
        @click="buzonSugerencias"
        @mouseover="popupTrue()"
        @mouseleave="popupFalse()"
      >
        <i class="os-icon os-icon-mail-14"></i>
        <div v-if="text" class="new-messages-count">
          {{ text }}
        </div>
      </div>
      <div
        class="
          top-icon top-settings
          os-dropdown-trigger os-dropdown-position-left
        "
      >
        <i class="os-icon os-icon-ui-46"></i>
        <div class="os-dropdown">
          <div class="icon-w">
            <i class="os-icon os-icon-ui-46"></i>
          </div>
          <ul>
            <li>
              <a href="/profile"
                ><i class="os-icon os-icon-user-male-circle2"></i
                ><span>Ajustes de Usuario</span></a
              >
            </li>
          </ul>
        </div>
      </div>
      <!--------------------  END - Settings Link in secondary top menu -------------------->
      <div class="logged-user-w">
        <div class="logged-user-i">
          <div class="avatar-w">
            <img alt v-bind:src="user.image" />
          </div>
          <div class="logged-user-menu color-style-bright">
            <a href="/profile">
              <div class="logged-user-avatar-info">
                <div class="avatar-w">
                  <img alt v-bind:src="user.image" />
                </div>
                <div class="logged-user-info-w">
                  <div class="logged-user-name" v-html="user.name"></div>
                  <div class="logged-user-role" v-html="user.email"></div>
                </div>
              </div>
            </a>
            <div class="bg-icon">
              <i class="os-icon os-icon-wallet-loaded"></i>
            </div>
            <ul>
              <li>
                <a href="#" @click="logout"
                  ><i class="os-icon os-icon-signs-11"></i
                  ><span>Cerrar Sesión</span></a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--------------------  START - User avatar and menu in secondary top menu -------------------->

      <!--------------------  END - User avatar and menu in secondary top menu -------------------->
    </div>
    <!--------------------END - Top Menu Controls -------------------->
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      text: "",
      popUpTel: false,
      showTopMenuModule: false,
      user: {
        name: "",
        image: "",
        email: "",
      },
    };
  },
  computed: {
    module() {
      return this.$store.getters.module;
    },
    modules() {
      return this.$store.getters.modules;
    },
  },
  created() {
    this.user.name = localStorage.getItem("name");
    this.user.email = localStorage.getItem("email");
    this.user.image = localStorage.getItem("image");
  },
  props: {
    source: String,
  },
  methods: {
    popupFalse() {
      this.text = "";
    },
    popupTrue() {
      this.text = "Nuevo";
    },
    popUpTelTrue() {
      this.popUpTel = true;
    },
    popUpTelFalse() {
      this.popUpTel = false;
    },
    buzonSugerencias() {
      let routeUrl = this.$router.resolve({
        name: "rrhh-buzon-suegerencias-public",
      });
      window.open(routeUrl.href, "_blank");
    },
    verExtensiones() {
      let routeUrl = this.$router.resolve({
        path: "/cat/extensiones/",
      });
      window.open(routeUrl.href, "_blank");
    },
    logout: function () {
      localStorage.removeItem("token");
      localStorage.removeItem("username");
      localStorage.removeItem("name");
      localStorage.removeItem("email");
      localStorage.removeItem("image");
      localStorage.removeItem("ocultar_checklist_info");
      this.$store.commit("SET_LAYOUT", "clean-layout");
      document.location.href = "/";
    },
    seleccionarModulo: function (currentMenu) {
      this.showTopMenuModule = false;
      this.$store.commit("SET_MODULE", currentMenu.name);
      this.$store.getters.module;
    },
  },
};
</script>
